import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { brandInfo } from '../mock';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/contact', label: 'Contact Us' },
    { path: '/gallery', label: 'Gallery' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo/Brand */}
          <Link to="/" className="flex items-center focus:outline-none focus:ring-0">
            <img 
              src="/logo.png" 
              alt={`${brandInfo.name} Logo`}
              className="w-28 h-28 sm:w-32 sm:h-32 object-contain bg-transparent"
              style={{ backgroundColor: 'transparent' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-all duration-300 hover:text-red-600 relative group focus:outline-none focus:ring-0 ${
                  isActive(link.path) ? 'text-red-600' : 'text-gray-700'
                }`}
              >
                {link.label}
                <span
                  className={`absolute left-0 bottom-0 h-0.5 bg-red-600 transition-all duration-300 ${
                    isActive(link.path) ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                ></span>
              </Link>
            ))}
          </nav>

          {/* Call Button - Desktop */}
          <div className="hidden md:flex items-center space-x-2">
            <Button
              asChild
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              <a href={`tel:${brandInfo.phones[0]}`}>
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-red-600 transition-colors focus:outline-none focus:ring-0"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2 border-t pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block py-2 px-4 rounded-lg text-sm font-medium transition-colors focus:outline-none focus:ring-0 ${
                  isActive(link.path)
                    ? 'bg-red-50 text-red-600'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={`tel:${brandInfo.phones[0]}`}
              className="block py-2 px-4 bg-red-600 text-white rounded-lg text-sm font-medium text-center focus:outline-none focus:ring-0"
            >
              <Phone className="w-4 h-4 inline mr-2" />
              Call {brandInfo.phones[0]}
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};